// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"ced53f03","419":"eb854fa9","563":"b0cd1d58","787":"84d8124f","942":"22b93c27"}[chunkId] + ".chunk.js";
};